export const invoice = {
  receiveType: [{
    value: 1, label: '未入账'
  }, {
    value: 2, label: '已入账'
  }],
  invoiceType: [{
    value: 1, label: '增值税专用发票'
  }, {
    value: 2, label: '普通发票'
  }]
}

export default {
  invoice
}



// WEBPACK FOOTER //
// ./src/data/invoice.js